import type { Location } from "api/schemas/shared/Treatment";

export function hasLateralLocation(location: Location): boolean {
  switch (location) {
    case "elbow":
    case "foot":
    case "hand":
    case "hip":
    case "knee":
    case "lower_leg":
    case "shoulder":
    case "wrist":
      return true;
    case "neck":
    case "lower_back":
    case "spine":
    case "upper_back":
      return false;
    default:
      return false;
  }
}
